import { useEffect, useState } from 'preact/hooks';
import { api, ApiError, type Release } from './api';

export type ReleaseState = { status: 'loading' } | { status: 'none' } | { status: 'error'; message: string } | { status: 'ready'; release: Release };

let cache: Promise<ReleaseState> | null = null;

/** Published desktop builds (GET /v1/releases/latest). 404 no_release → nothing is offered. */
export function useRelease(): ReleaseState {
  const [s, setS] = useState<ReleaseState>({ status: 'loading' });
  useEffect(() => {
    cache ??= api<Release>('/v1/releases/latest')
      .then((release): ReleaseState => ({ status: 'ready', release }))
      .catch((e): ReleaseState => {
        cache = null;
        return e instanceof ApiError && e.status === 404 ? { status: 'none' } : { status: 'error', message: (e as Error).message };
      });
    let live = true;
    cache.then((r) => live && setS(r));
    return () => { live = false; };
  }, []);
  return s;
}
